export function findComponentsById(id) {
    return $(`div[data-component="${id}"]`)
}